import * as Yup from 'yup';

// FNP-1191 CRUD half — validation for the CREATE form. There is no edit form,
// because the neutral schema has no `updateDnsZone` (verified against the
// deployed TEST API).
//
// ⚠️ VALIDATE SHAPE, NOT POLICY. The provider is the authority on whether a
// name is acceptable, and it will say so as VALIDATION_REJECTED with its own
// message. What is checked here is only what would be a WASTED ROUND TRIP —
// an empty name, a trailing dot the adapter has told us it normalises, obvious
// whitespace. Re-implementing a registry's rules locally is how a form starts
// refusing names the provider would have happily accepted.

// Deliberately permissive: labels separated by dots, each starting and ending
// alphanumeric, hyphens allowed inside. Rejects the shapes that are certainly
// wrong (spaces, leading/trailing dots, empty labels) and nothing subtler.
const ZONE_NAME = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i;

export const RecordSchema = Yup.object()
                               .shape({
                                          connectionId: Yup.string()
                                                           .required('Choose the connection to create this zone through'),
                                          name: Yup.string()
                                                   .required('Required')
                                                   // ⚠️ The adapter normalises the trailing dot so the
                                                   // core never has to — but a name typed WITH one is
                                                   // worth catching here, because an operator who
                                                   // typed it deliberately should be told it is not
                                                   // needed rather than silently having it removed.
                                                   .test(
                                                       'no-trailing-dot',
                                                       'Leave off the trailing dot — it is added by the provider where needed',
                                                       value => !value || !value.endsWith('.'),
                                                   )
                                                   .test(
                                                       'no-whitespace',
                                                       'A zone name cannot contain spaces',
                                                       value => !value || !/\s/.test(value),
                                                   )
                                                   .matches(
                                                       ZONE_NAME,
                                                       'Enter a domain name such as example.com',
                                                   ),
                                          comment: Yup.string()
                                                      .max(256, 'Keep the comment under 256 characters'),
                                      });
